import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { AppointmentSlot } from "@customTypes/appointment";
import { Pagination } from "@customTypes/index";

import { appointmentQKeys } from "./queryKeys";


const select = (res: any) => {
  //   console.log(res.data);
  const pagination: Partial<Pagination> = {
    page: res.data.page,
    pageSize: res.data.page_size,
    pageCount: res.data.page_count,
    total: res.data.total,
  };

  const newData = [] as AppointmentSlot[];
  if (res.data.data.length) {
    for (const i in res.data.data) {
      const { _id, start_time, end_time, quantity, doctor_assigned } =
        res.data.data[i];
      // console.log(details);

      newData.push({
        id: _id,
        startTime: new Date(start_time),
        endTime: new Date(end_time),
        quantity,
        doctor: {
          id: doctor_assigned?._id,
          fullName: doctor_assigned?.full_name,
        },
      });
    }
    return { newData, pagination };

    // console.log(newData);
  }
  return null;
};

interface QueryProps {
  isEnabled?: boolean;
  doctorAssigned?: string;
  withDoctorAssigned?: boolean;
  pagination?: Partial<Pagination>;
  startDate?: string;
  endDate?: string;
  booked?: boolean;
  managementView?: boolean;
}

export const useGetAppointmentSlots = ({
  doctorAssigned,
  withDoctorAssigned,
  isEnabled = true,
  pagination,
  startDate,
  endDate,
  booked,
  managementView = false,
}: QueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: appointmentQKeys.slotsWithFilters({
      doctorAssigned,
      withDoctorAssigned,
      pagination,
      startDate,
      endDate,
      booked,
      managementView,
    }),
    queryFn: () => {
      return api.get("appointments/v-slots", {
        params: {
          ...(doctorAssigned && { doctor_assigned: doctorAssigned }),
          ...(typeof withDoctorAssigned !== "undefined" && {
            with_doctor_assigned: withDoctorAssigned,
          }),
          ...(pagination && {
            page: pagination.page,
            page_size: pagination.pageSize,
          }),
          ...(startDate && { start_time: startDate, end_time: endDate }),
          ...(typeof booked !== "undefined" && { booked }),
          ...(managementView && { management_view: true }),
        },
      });
    },
    select,
    enabled: isEnabled && !(startDate && !endDate),
    staleTime: Infinity,

    onError: (res: any) => {
      console.error("[From Get Appointment Slots]", res);
      handleErrors(res, "query");
    },
  });
};
